/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FieldSignatureCreateV1Dto = {
  /**
   * Height of the field in pixels
   */
  height?: number;
  /**
   * Page number the field is located on
   */
  page: number;
  /**
   * Type of the field
   */
  type: FieldSignatureCreateV1Dto.type;
  /**
   * Width of the field in pixels
   */
  width?: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  x: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  y: number;
  /**
   * UUID of the document the field belongs to
   */
  document_id?: string;
  /**
   * Reason for the signature
   */
  reason?: string | null;
};
export namespace FieldSignatureCreateV1Dto {
  /**
   * Type of the field
   */
  export enum type {
    CHECKBOX = 'checkbox',
    MENTION = 'mention',
    RADIO_GROUP = 'radio_group',
    SIGNATURE = 'signature',
    TEXT = 'text',
  }
}
